<template>
	<div>
		<v-file-input
			outlined
			accept=".pdf"
			label="Add File..."
			v-model="tmpFile"
			@change="fileChanged()"
			:disabled="!!disabled"
			v-if="!readonly"
		></v-file-input>
		<div v-if="files.length > 0" class="mb-3">
			<v-row
				class="downloadFile mb-3 mx-0"
				v-for="(file, index) in files"
				v-bind:key="file"
			>
				<v-avatar tile size="36" color="white">
					<h3 class="primary--text">{{ index + 1 }}</h3>
				</v-avatar>
				<v-btn
					v-if="file"
					:color="dark ? 'white' : 'primary'"
					class="text-transform-none ml-3"
					:outlined="!dark"
					@click="downloadFile(file)"
					><v-icon left>fas fa-download</v-icon>{{ filename(file) }}</v-btn
				>
				<v-btn
					color="error"
					outlined
					class="ml-2"
					v-if="
						file && !readonly && fileInfo[file] && fileInfo[file].temporary == 1
					"
					@click="removeFile(file)"
					>Delete file</v-btn
				>
				<v-btn
					color="warning"
					outlined
					class="ml-2"
					v-else-if="
						file && !readonly && fileInfo[file] && fileInfo[file].temporary == 0
					"
					@click="removeFile(file)"
					>Remove file</v-btn
				>
			</v-row>
		</div>
		<div v-else class="mb-3">
			<v-row class="downloadFile mb-3 mx-0">
				<p><i>No files available to download</i></p>
			</v-row>
		</div>
	</div>
</template>
<script>
import FilesAPI from "../api/files/files"
import LoadingState from "../consts/LoadingState"
export default {
	name: "FileUploader",
	data() {
		return {
			tmpFile: null,
			fileInfo: {}
		}
	},
	methods: {
		getFileCount() {
			return this.files.length
		},
		addFileID(id) {
			let arr = this.files
			arr.push(id)
			let newFiles = arr.join(",")
			this.$emit("input", newFiles)
			this.$emit("filesChanged", this.getFileCount())
		},
		removeFileID(id) {
			let arr = this.files
			let idx = arr.indexOf(id)
			arr.splice(idx, 1)
			this.$emit("input", arr.length > 0 ? arr.join(",") : "")
			this.$emit("filesChanged", this.getFileCount())
		},
		fileChanged() {
			if (!this.tmpFile) {
				return
			}
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Uploading File...",
				{ root: true }
			)
			console.log("checking create function",this.tmpFile)
			FilesAPI.createFile(this.tmpFile.name, this.tmpFile)
				.then(file => {
					console.log("file",file)
					this.addFileID(file.id)
					this.tmpFile = null
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"File was successfully added!",
						console.log("file added notification",file),
						{ root: true }
					)
				})
				.catch(err => {
					console.error(err)
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						err,
						{ root: true }
					)
				})
		},
		removeFile(fileID) {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Removing File...",
				{ root: true }
			)
			if (this.fileInfo[fileID].temporary == 0) {
				this.removeFileID(fileID)
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
					"File was successfully removed!",
					{ root: true }
				)
				return
			}
			FilesAPI.deleteFile(fileID)
				.then(() => {
					this.removeFileID(fileID)
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"File was successfully deleted!",
						{ root: true }
					)
				})
				.catch(err => {
					console.error(err)
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						err,
						{ root: true }
					)
				})
		},
		downloadFile(fileID) {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Downloading file...",
				{ root: true }
			)
			let filename = this.filename(fileID)
			FilesAPI.download("" + fileID, filename.slice(0, -4))
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"File was successfully downloaded!",
						{ root: true }
					)
				})
				.catch(err => {
					console.error(err)
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						err,
						{
							root: true
						}
					)
				})
		},
		filename(fileID) {
			console.log("fileID",fileID)
			console.log("fileInfo",this.fileInfo[fileID])
			if (this.fileInfo[fileID]) {
				console.log("fileInfo",this.fileInfo[fileID])
				return this.fileInfo[fileID].name
			}
			return this.name ? this.name + ".pdf" : "attachment.pdf"
		}
	},
	computed: {
		files() {
			if (!this.value) {
				return []
			}
			let arr = (this.value + "").split(",")
			if (arr[0] == "") {
				return []
			} else {
				return arr
			}
		}
	},
	props: ["value", "disabled", "readonly", "dark", "name"],
	async mounted() {
		this.$store.dispatch(
			"loading/" + LoadingState.ACTION_START_LOADING,
			"Getting File Info...",
			{ root: true }
		)
		for (let id of this.files) {
			let info = await FilesAPI.info(id).catch(err => {
				console.error(err)
			})
			this.$set(this.fileInfo, id, info)
			console.log("fileInfo on mount",this.fileInfo)
		}
		this.$store.dispatch("loading/" + LoadingState.ACTION_END_LOADING, null, {
			root: true
		})
	},
	watch: {
		value: async function() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Getting File Info...",
				{ root: true }
			)
			for (let id of this.files) {
				let info = await FilesAPI.info(id).catch(err => {
					console.error(err)
				})
				this.$set(this.fileInfo, id, info)
				console.log("fileInfo on watch",this.fileInfo)
			}
			this.$store.dispatch("loading/" + LoadingState.ACTION_END_LOADING, null, {
				root: true
			})
		}
	}
}
</script>
<style scoped>
.text-transform-none {
	text-transform: none !important;
}
</style>
